import { Component, inject, OnInit } from '@angular/core'
import { RouterOutlet } from '@angular/router';
import { NgbModalConfig, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap'
import { OAuthService } from 'angular-oauth2-oidc'
import { authConfig } from './core/data-access/configuration/auth.config'
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks'
import localeFr from '@angular/common/locales/fr'
import {registerLocaleData} from "@angular/common"

registerLocaleData(localeFr)
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  constructor() {
    const configModal = inject(NgbModalConfig)
    const configTooltip = inject(NgbTooltipConfig)
    const oauthService = inject(OAuthService)

    configModal.centered = true

    configTooltip.container = 'body'
    configTooltip.openDelay = 600

    oauthService.configure(authConfig)
    oauthService.tokenValidationHandler = new JwksValidationHandler()
    oauthService.setStorage(localStorage)
  }
  ngOnInit(): void {
    this.removeStartupLoader()
  }

  removeStartupLoader(): void {
    const startupLoader: HTMLElement | null = document.getElementById('startup-loader')
    if (startupLoader) {
      startupLoader.remove()
    }
  }

}

